'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var StandardTabPane = _react2['default'].createClass({
    displayName: 'StandardTabPane',

    propTypes: {
        image: _react2['default'].PropTypes.string,
        title: _react2['default'].PropTypes.string.isRequired,
        description: _react2['default'].PropTypes.node.isRequired,
        link: _react2['default'].PropTypes.string,
        linkText: _react2['default'].PropTypes.string,

        // TODO: this prop needs to be required, otherwise React
        // will throw an exception since render() will return undefined (CC)
        paneType: _react2['default'].PropTypes.string,
        bottomImage: _react2['default'].PropTypes.string
    },

    render: function render() {

        var tileLinkButton = null;
        if (this.props.link && this.props.linkText) {
            tileLinkButton = _react2['default'].createElement(
                'div',
                { className: 'l-margin-t-15' },
                _react2['default'].createElement(_button2['default'], {
                    buttonText: this.props.linkText,
                    buttonLink: this.props.link,
                    buttonHoverColor: 'cerulean',
                    wrapText: true,
                    openInNewWindow: true })
            );
        }

        var tileReturnType = _react2['default'].createElement(
            'div',
            { className: 'columns small-8 small-text-center small-centered' },
            _react2['default'].createElement(
                'div',
                { className: 'm-tabs_tiles--copy-container' },
                _react2['default'].createElement(
                    'h4',
                    { className: 'm-tabs_tiles--pane-header b' },
                    this.props.title
                ),
                _react2['default'].createElement(
                    'p',
                    null,
                    this.props.description
                ),
                tileLinkButton
            )
        );
        var tabReturnType = _react2['default'].createElement(
            'div',
            null,
            _react2['default'].createElement(
                'div',
                { className: 'show-for-large-up large-6 columns' },
                _react2['default'].createElement('img', { src: this.props.image, className: 'embedded-image' })
            ),
            _react2['default'].createElement(
                'div',
                { className: 'small-12 large-6 small-text-center large-text-left columns' },
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'small-10 small-centered large-uncentered columns' },
                        _react2['default'].createElement(
                            'h3',
                            null,
                            this.props.title
                        )
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'small-10 small-centered large-uncentered columns' },
                        _react2['default'].createElement(
                            'div',
                            { className: 'l-padding-v-20' },
                            _react2['default'].createElement(
                                'p',
                                null,
                                this.props.description
                            )
                        )
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'row' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'small-12 columns' },
                        _react2['default'].createElement(_button2['default'], {
                            buttonText: this.props.linkText ? this.props.linkText : 'LEARN MORE',
                            buttonLink: this.props.link ? this.props.link : '/api/features',
                            onMouseEnter: this.onMouseEnter,
                            onMouseLeave: this.onMouseLeave,
                            openInNewWindow: true })
                    )
                )
            )
        );

        if (this.props.paneType == 'tile') {
            return tileReturnType;
        } else if (this.props.paneType == 'tab') {
            return tabReturnType;
        }
    }
});

module.exports = StandardTabPane;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/standard-tab-pane.jsx
 ** module id = 862
 ** module chunks = 0
 **/